module.exports = __webpack_public_path__ + "img/بنر-چاپی.c3178643.png";